import React from "react";
import iconoExpande from "../../assets/expande-icono.png";
import ExpandePublicLayout from "./ExpandePublicLayout";

export default function ExpandeAppPage() {
  return (
    <ExpandePublicLayout title="Expande | App">
      <section className="expub-hero">
        <div>
          <p className="expub-kicker">Expande Bolivia</p>
          <h1 className="expub-title">Conecta con tu club saludable desde el celular.</h1>
          <p className="expub-copy">
            Expande permite a usuarios, socios y anfitriones interactuar con clubes saludables,
            consultar productos, gestionar pedidos y acceder a funciones de la comunidad desde
            una cuenta personal.
          </p>
          <div className="expub-actions">
            <a className="expub-button expub-button-primary" href="/expande/app/descarga-oficial">
              Descargar app
            </a>
            <a className="expub-button expub-button-secondary" href="/expande/app/soporte">
              Contactar soporte
            </a>
          </div>
        </div>
        <div className="expub-visual" aria-hidden="true">
          <img src={iconoExpande} alt="" />
        </div>
      </section>

      <section className="expub-grid" aria-label="Funciones principales">
        <article className="expub-card">
          <h2>Cuenta personal</h2>
          <p>Registro con correo, Google o Apple para acceder de forma segura a la experiencia de la app.</p>
        </article>
        <article className="expub-card">
          <h2>Clubes saludables</h2>
          <p>Acceso a información de clubes, productos saludables, pedidos y actividades disponibles.</p>
        </article>
        <article className="expub-card">
          <h2>Privacidad y control</h2>
          <p>La app permite eliminar la cuenta desde el perfil y consultar la política de privacidad.</p>
        </article>
      </section>
    </ExpandePublicLayout>
  );
}
